import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import OrcamentoDemo from './pages/OrcamentoDemo';
import OrcamentoConfigurar from './pages/OrcamentoConfigurar';
import OrcamentoPublico from './pages/OrcamentoPublico';
import GerenciarAssinatura from './pages/GerenciarAssinatura';
import AgendaDemo from './pages/AgendaDemo';
import AgendaConfigurar from './pages/AgendaConfigurar';
import AgendaPublica from './pages/AgendaPublica';
import PainelProfissional from './pages/PainelProfissional';
import MeuTrampoDemo from './pages/MeuTrampoDemo';
import MeuTrampoConfigurar from './pages/MeuTrampoConfigurar';
import MeuTrampoPublico from './pages/MeuTrampoPublico';
import MeuTrampoAvaliar from './pages/MeuTrampoAvaliar';
import MeuTrampoPainel from './pages/MeuTrampoPainel';
import ProDemo from './pages/ProDemo';
import ProConfigurar from './pages/ProConfigurar';
import ProPublico from './pages/ProPublico';
import ProPainel from './pages/ProPainel';
import ClienteJaDemo from './pages/ClienteJaDemo';
import ClienteJaConfigurar from './pages/ClienteJaConfigurar';
import ClienteJaPainel from './pages/ClienteJaPainel';
import PostaJaDemo from './pages/PostaJaDemo';
import PostaJaConfigurar from './pages/PostaJaConfigurar';
import PostaJaPainel from './pages/PostaJaPainel';
import AdminDashboard from './pages/AdminDashboard';
// EU Landing Page Engine
import EUTemplateLibrary from './pages/EUTemplateLibrary';
import EUBusinessPublic from './pages/EUBusinessPublic';
import EUPreview from './pages/EUPreview';

// Redirect component for short links
const ProRedirect = () => {
  const { slug } = useParams();
  // Avoid redirecting known routes
  const reservedSlugs = ['orcamento', 'agenda', 'meutrampo', 'pro', 'assinatura', 'admin', 'clienteja', 'postaja', 'eu'];
  if (reservedSlugs.includes(slug)) {
    return <Navigate to="/" replace />;
  }
  return <Navigate to={`/pro/${slug}`} replace />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          {/* Orçamento na Hora */}
          <Route path="/orcamento" element={<OrcamentoDemo />} />
          <Route path="/orcamento/configurar" element={<OrcamentoConfigurar />} />
          <Route path="/orcamento/:slug" element={<OrcamentoPublico />} />
          {/* Agenda Cheia */}
          <Route path="/agenda" element={<AgendaDemo />} />
          <Route path="/agenda/configurar" element={<AgendaConfigurar />} />
          <Route path="/agenda/:slug" element={<AgendaPublica />} />
          <Route path="/painel/:slug" element={<PainelProfissional />} />
          {/* Meu Trampo */}
          <Route path="/meutrampo" element={<MeuTrampoDemo />} />
          <Route path="/meutrampo/configurar" element={<MeuTrampoConfigurar />} />
          <Route path="/meutrampo/painel/:slug" element={<MeuTrampoPainel />} />
          <Route path="/meutrampo/:slug" element={<MeuTrampoPublico />} />
          <Route path="/meutrampo/:slug/avaliar/:code" element={<MeuTrampoAvaliar />} />
          {/* AtivaJá Pro */}
          <Route path="/pro" element={<ProDemo />} />
          <Route path="/pro/configurar" element={<ProConfigurar />} />
          <Route path="/pro/painel/:slug" element={<ProPainel />} />
          <Route path="/pro/:slug" element={<ProPublico />} />
          {/* ClienteJá */}
          <Route path="/clienteja" element={<ClienteJaDemo />} />
          <Route path="/clienteja/configurar" element={<ClienteJaConfigurar />} />
          <Route path="/clienteja/painel/:slug" element={<ClienteJaPainel />} />
          {/* PostaJá */}
          <Route path="/postaja" element={<PostaJaDemo />} />
          <Route path="/postaja/configurar" element={<PostaJaConfigurar />} />
          <Route path="/postaja/painel/:slug" element={<PostaJaPainel />} />
          {/* Admin Dashboard */}
          <Route path="/admin" element={<AdminDashboard />} />
          {/* EU Landing Page Engine */}
          <Route path="/eu/templates" element={<EUTemplateLibrary />} />
          <Route path="/eu/preview/:slug" element={<EUPreview />} />
          <Route path="/eu/:slug" element={<EUBusinessPublic />} />
          {/* Link curto - redirect /:slug para /pro/:slug */}
          <Route path="/:slug" element={<ProRedirect />} />
          {/* Gerenciamento */}
          <Route path="/assinatura/:slug" element={<GerenciarAssinatura />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
